import service from "@/utils/request.js"
import Qs from 'qs'

//公共控件 获取质检单详情
export function qualityDetails(data){
    return service.request({
        url:"/quality/details",
        method: "post",
        data:Qs.stringify(data),
    });
}